import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VendorType } from '../../enums/vendor/vendor-type.enum';
import { DeviceObservationResponseDto } from '../../model/device/device-observation-response-dto';
import { DeviceResponseDto } from '../../model/device/device-response-dto';
import { LabisExaminationRequestDto } from '../../model/laboratory/lab-examination-request-dto';
import { LabDetailsResponseDto } from '../../model/laboratory/lab-observation-response-dto';
import { ContractorResponseDto } from '../../model/vendor/contractor-response-dto';
import { HelperService } from '../helper.service';
import { HttpClientService } from '../http-client.service';

@Injectable({
    providedIn: 'root',
})
export class VendorClientService {
    private httpClient = inject(HttpClientService);
    private helper = inject(HelperService);

    public getContractor(contractorId: number, vendorType: VendorType): Observable<ContractorResponseDto[]> {
        return this.httpClient.get(this.helper.getLaboratoryApiUrl(`/contractors/${contractorId}/vendorContractors/${vendorType}`));
    }

    public getContractorDevices(contractorId: number, vendorContractorId: number): Observable<DeviceResponseDto[]> {
        return this.httpClient.get(this.helper.getLaboratoryApiUrl(`/contractors/${contractorId}/vendorContractors/${vendorContractorId}/devices`));
    }

    public getDeviceObservations(contractorId: number, vendorContractorId: number, deviceId: string): Observable<DeviceObservationResponseDto[]> {
        return this.httpClient.get(
            this.helper.getLaboratoryApiUrl(`/contractors/${contractorId}/vendorContractors/${vendorContractorId}/devices/${deviceId}/observations`),
        );
    }

    public getLaboratoryDetails(contractorId: number, labId: number): Observable<LabDetailsResponseDto[]> {
        return this.httpClient.get(this.helper.getLaboratoryApiUrl(`/contractors/${contractorId}/vendorContractors/${labId}/observations`));
    }

    public createLabisReservationExamination(
        contractorId: number,
        prereservationId: string,
        request: LabisExaminationRequestDto,
    ): Observable<number> {
        return this.httpClient.post(
            this.helper.getLaboratoryApiUrl(`/contractors/${contractorId}/reservations/${prereservationId}/examinations/labis`),
            request,
        );
    }
}
